import type { CtaButtonProps } from '@/components/landing-page/components/cta-button';

export const defaults: Required<CtaButtonProps> = {
  text: 'Vollmacht ansehen',
  className: '',
  optimizely: 'landing-cta',
  disabled: false,
  fullWidth: false,
};
